import jwtDecode from 'jwt-decode';

// A API continua validando o JWT. Aqui os IDs apenas identificam a interface da sessão.
export function normalizarUsuario(user) {
  if (!user) return null;
  let claims = {};
  try { if (user.token) claims = jwtDecode(user.token); } catch { /* Sessões anteriores podem não ter IDs armazenados. */ }
  const idCliente = Number(claims.IdClienteClaim ?? user.idCliente ?? 0);
  const idUser = Number(claims.UserIdClaim ?? user.idUser ?? 0);
  const possuiIdCliente = user.idCliente != null || claims.IdClienteClaim != null;
  return { ...user, idCliente: possuiIdCliente ? idCliente : undefined, idUser,
    isClient: possuiIdCliente ? idCliente > 0 : user.isClient === true };
}
